// src/auth/AuthContext.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // { id, name, role } o null
  const [token, setToken] = useState(null); // JWT si lo usas

  // Cargar sesión previa guardada por LoginPassword (SR_USER / SR_TOKEN)
  useEffect(() => {
    try {
      const u = localStorage.getItem("SR_USER");
      const t = localStorage.getItem("SR_TOKEN");
      setUser(u ? JSON.parse(u) : null);
      setToken(t || null);
    } catch {}
  }, []);

  // Escuchar cambios desde login/logout (evento opcional)
  useEffect(() => {
    function onAuthUpdated(){
      try {
        const u = localStorage.getItem("SR_USER");
        const t = localStorage.getItem("SR_TOKEN");
        setUser(u ? JSON.parse(u) : null);
        setToken(t || null);
      } catch {}
    }
    window.addEventListener("sr-auth-updated", onAuthUpdated);
    return () => window.removeEventListener("sr-auth-updated", onAuthUpdated);
  }, []);

  // APIs mínimas (puedes reemplazar por tus llamadas reales)
  async function loginWithPassword({ phone, password }) {
    // DEMO: usuario admin por defecto (cámbialo por tu API cuando quieras)
    const demoUser = { id: 1, name: "Admin", role: "admin", phone };
    setUser(demoUser);
    setToken("DEMO_TOKEN");
    localStorage.setItem("SR_USER", JSON.stringify(demoUser));
    localStorage.setItem("SR_TOKEN", "DEMO_TOKEN");
    try { window.dispatchEvent(new Event("sr-auth-updated")); } catch {}
    return demoUser;
  }

  function logout() {
    setUser(null);
    setToken(null);
    localStorage.removeItem("SR_USER");
    localStorage.removeItem("SR_TOKEN");
    try { window.dispatchEvent(new Event("sr-auth-updated")); } catch {}
  }

  const value = useMemo(() => ({ user, token, setUser, setToken, loginWithPassword, logout }), [user, token]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
